import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2386f2ef")

_pushScopeId("data-v-2386f2ef")
const _hoisted_1 = { class: "flex flex-col justify-between" }
const _hoisted_2 = { class: "w-full flex-grow flex flex-col justify-center" }
const _hoisted_3 = { class: " text-left flex flex-wrap flex-col py-8 mx-5 mb-3 mt-3" }
const _hoisted_4 = {
  class: "select-none text-xl font-bold w-full text-white",
  "data-testid": "question-title"
}
const _hoisted_5 = {
  id: "alternatives",
  class: "p-5 flex flex-wrap content-center justify-between rounded-md"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_blue_button = _resolveComponent("blue-button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("span", _hoisted_4, _toDisplayString(_ctx.question.title), 1)
      ])
    ]),
    _createVNode("div", _hoisted_5, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.question.alternatives, (alternative) => {
        return (_openBlock(), _createBlock(_component_blue_button, {
          key: alternative,
          "data-testid": alternative,
          "show-result": _ctx.showResults,
          "is-correct": alternative === _ctx.question.rightAlternative,
          class: "alternative h-12 font-semibold text-sm",
          onClick: ($event: any) => (_ctx.onSelect(alternative, _ctx.question.rightAlternative))
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(alternative), 1)
          ]),
          _: 2
        }, 1032, ["data-testid", "show-result", "is-correct", "onClick"]))
      }), 128))
    ])
  ]))
})